import api from '@helpers/api';

// ── Form ──────────────────────────────────────────────────────────────────────

export async function apiCreateForm(communityId, payload) {
    const res = await api.post(`communities/${communityId}/forms`, payload);
    if (!res?.data?.id) throw new Error('Failed to create form');
    return res.data;
}

export async function apiUpdateForm(formId, payload) {
    const res = await api.patch(`forms/${formId}`, payload);
    if (!res?.data?.id) throw new Error('Failed to update form');
    return res.data;
}

export async function apiDeleteForm(formId) {
    await api.delete(`forms/${formId}`);
}

export async function apiGetForm(formId) {
    const res = await api.get(`forms/${formId}`);
    if (!res?.data?.id) throw new Error('Failed to load form');
    return res.data;
}

export async function apiListForms(communityId) {
    const res = await api.get(`communities/${communityId}/forms`);
    return res?.data ?? [];
}

// ── Steps ─────────────────────────────────────────────────────────────────────

export async function apiCreateStep(formId, payload) {
    const res = await api.post(`forms/${formId}/steps`, payload);
    if (!res?.data?.id) throw new Error('Failed to create step');
    return res.data;
}

export async function apiUpdateStep(formId, stepId, payload) {
    const res = await api.patch(`forms/${formId}/steps/${stepId}`, payload);
    if (!res?.data?.id) throw new Error('Failed to update step');
    return res.data;
}

export async function apiDeleteStep(formId, stepId) {
    await api.delete(`forms/${formId}/steps/${stepId}`);
}

export async function apiReorderSteps(formId, orderedStepIds) {
    const res = await api.post(`forms/${formId}/steps/reorder`, { steps: orderedStepIds });
    return res?.data ?? [];
}

// ── Questions ─────────────────────────────────────────────────────────────────

export async function apiCreateQuestion(formId, stepId, payload) {
    const res = await api.post(`forms/${formId}/steps/${stepId}/questions`, payload);
    if (!res?.data?.id) throw new Error('Failed to create question');
    return res.data;
}

export async function apiUpdateQuestion(formId, stepId, questionId, payload) {
    const res = await api.patch(`forms/${formId}/steps/${stepId}/questions/${questionId}`, payload);
    if (!res?.data?.id) throw new Error('Failed to update question');
    return res.data;
}

export async function apiDeleteQuestion(formId, stepId, questionId) {
    await api.delete(`forms/${formId}/steps/${stepId}/questions/${questionId}`);
}

export async function apiReorderQuestions(formId, stepId, orderedQuestionIds) {
    const res = await api.post(`forms/${formId}/steps/${stepId}/questions/reorder`, { questions: orderedQuestionIds });
    return res?.data ?? [];
}

// ── Form Actions ──────────────────────────────────────────────────────────────

export async function apiCreateFormAction(formId, payload) {
    const res = await api.post(`forms/${formId}/actions`, payload);
    if (!res?.data?.id) throw new Error('Failed to create form action');
    return res.data;
}

export async function apiUpdateFormAction(formId, actionId, payload) {
    const res = await api.patch(`forms/${formId}/actions/${actionId}`, payload);
    if (!res?.data?.id) throw new Error('Failed to update form action');
    return res.data;
}

export async function apiDeleteFormAction(formId, actionId) {
    await api.delete(`forms/${formId}/actions/${actionId}`);
}
